// src/components/tabs/TabDescriptors.jsx
// Mirrors reldescript.inc — badges with add/remove, autocomplete search

import React, { useState, useEffect, useRef } from 'react';
import { tabsApi } from '../../services/api';
import { useTexts, TXT } from '../../context/TextContext';
import { useToast } from '../../context/ToastContext';

export default function TabDescriptors({ docId, onHide }) {
  const { t } = useTexts();
  const { showToast } = useToast();
  const [data, setData]         = useState(null);
  const [loading, setLoading]   = useState(true);
  const [query, setQuery]       = useState('');
  const [suggestions, setSugg]  = useState([]);
  const searchTimer = useRef(null);

  useEffect(() => { load(); }, [docId]);

  const load = async () => {
    setLoading(true);
    try {
      const res = await tabsApi.getDescriptors(docId);
      setData(res.data);
    } catch { setData({ canView: false, canEdit: false, descriptors: [] }); }
    finally { setLoading(false); }
  };

  const handleSearch = (q) => {
    setQuery(q);
    clearTimeout(searchTimer.current);
    if (!q.trim()) { setSugg([]); return; }
    searchTimer.current = setTimeout(async () => {
      try {
        const res = await tabsApi.searchDescriptors(q);
        setSugg(res.data);
      } catch { setSugg([]); }
    }, 300);
  };

  const handleAdd = async (desId) => {
    try {
      await tabsApi.addDescriptor(docId, desId);
      setQuery(''); setSugg([]);
      load();
    } catch (err) { showToast(err.response?.data?.error || t(TXT.TRANSACTION_ERROR, 'Error'), 'error'); }
  };

  const handleRemove = async (desId) => {
    try {
      await tabsApi.removeDescriptor(docId, desId);
      load();
    } catch (err) { showToast(err.response?.data?.error || t(TXT.TRANSACTION_ERROR, 'Error'), 'error'); }
  };

  if (loading) return <div className="text-center p-3"><div className="spinner-border spinner-border-sm" /></div>;
  if (!data?.canView) { if (onHide) onHide(); return null; }

  return (
    <div className="container-fluid">
      {/* Descriptor badges */}
      <div className="row mt-2">
        <div className="col-12">
          {data.descriptors.map(d => (
            <span key={d.id} className="badge text-bg-secondary p-2 m-1">
              {data.canEdit && (
                <i className="fa-solid fa-square-minus fa-1x me-1"
                   style={{ cursor: 'pointer' }}
                   onClick={() => handleRemove(d.id)} />
              )}
              {d.name}
            </span>
          ))}
        </div>
      </div>

      {/* Add descriptor */}
      {data.canEdit && (
        <div className="row mt-3">
          <div className="col-12 d-flex align-items-center gap-2 position-relative">
            <input
              type="text"
              className="form-control form-control-sm"
              style={{ width: '250px' }}
              placeholder={`${t(TXT.SEARCH, 'Buscar')} ${t(TXT.KEYWORDS_TAB, 'descriptor')}…`}
              value={query}
              onChange={e => handleSearch(e.target.value)}
            />

            {/* Autocomplete dropdown */}
            {suggestions.length > 0 && (
              <ul className="list-group position-absolute shadow"
                  style={{ top: '100%', left: 0, width: '250px', zIndex: 1000 }}>
                {suggestions.map(s => (
                  <li key={s.id}
                      className="list-group-item list-group-item-action py-1"
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleAdd(s.id)}>
                    {s.name}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
